const translation = {
  'howToMakeGoodApp.seo.title': 'Cómo hacer una buena aplicación para un curso TEFL',
  'howToMakeGoodApp.seo.description':
    '¿Quieres tener las mejores posibilidades de ser aceptado en el curso Trinity CertTESOL en Barcelona y Sevilla? Saber más.',
  'howToMakeGoodApp.sec1.title': 'Cómo hacer una solicitud que destaque',
  'howToMakeGoodApp.sec2.title':
    'El proceso de solicitud para el curso Trinity CertTESOL en TEFL Iberia es el siguiente:',
  'howToMakeGoodApp.sec2.ben1': 'Completa el formulario de solicitud en línea. ',
  'howToMakeGoodApp.sec2.ben2': 'Completa un breve quiz de nivel de inglés en línea.',
  'howToMakeGoodApp.sec2.ben3':
    'Realiza una entrevista con el coordinador del curso (por teléfono / Skype / FaceTime / Whatsapp / en persona en la escuela).',
};

export default translation;
